import { AmountField, DateField, TextField } from "./AdministrationFields";
import { emptyStyle, primaryButtonStyle, secondaryButtonStyle } from "../styles/administrationModalStyles";
import { creditCellStyle, creditHeaderStyle, creditTableContainerStyle, creditTableStyle } from "../styles/administrationStyles";

export function EhpadCreditsTable({
    rows,
    drafts,
    additions,
    loading,
    savingIds,
    onChange,
    onAdditionChange,
    onAdd,
    onSave,
    onCancel,
}) {
    if (loading) return <p style={emptyStyle}>Chargement…</p>;
    if (rows.length === 0) return <p style={emptyStyle}>Aucun EHPAD trouvé.</p>;

    return (
        <div style={creditTableContainerStyle}>
            <table style={creditTableStyle}>
                <thead>
                    <tr>
                        <th style={creditHeaderStyle}>EHPAD</th>
                        <th style={creditHeaderStyle}>Montant</th>
                        <th style={creditHeaderStyle}>Date d’envoi</th>
                        <th style={creditHeaderStyle}>Remarque / Retour</th>
                        <th style={creditHeaderStyle}>Date de suivi</th>
                        <th style={creditHeaderStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map(row => {
                        const current = drafts[row.ehpadId] || row;
                        const dirty = Boolean(drafts[row.ehpadId]);
                        const saving = Boolean(savingIds[row.ehpadId]);
                        return (
                            <tr key={row.ehpadId} style={{ background: dirty ? "#eef2ff" : "white" }}>
                                <td style={creditCellStyle}>
                                    <strong style={{ display: "block", color: "#111827" }}>{row.ehpadName}</strong>
                                    {row.ehpadCode && <span style={{ color: "#64748b", fontSize: "12px" }}>{row.ehpadCode}</span>}
                                </td>
                                <td style={{ ...creditCellStyle, minWidth: "230px" }}>
                                    <div style={{ display: "grid", gap: "8px" }}>
                                        <div style={{ display: "grid", gap: "4px" }}>
                                            <strong style={{ fontSize: "12px", color: "#374151" }}>Total :</strong>
                                            <AmountField
                                                label={`Montant total ${row.ehpadName}`}
                                                value={current.amount}
                                                onChange={value => onChange(row, { amount: value })}
                                            />
                                        </div>
                                        <div style={{ display: "grid", gap: "4px" }}>
                                            <strong style={{ fontSize: "12px", color: "#374151" }}>Ajouter :</strong>
                                            <div style={{ display: "flex", gap: "7px", alignItems: "center" }}>
                                                <AmountField
                                                    label={`Montant à ajouter ${row.ehpadName}`}
                                                    value={additions[row.ehpadId]}
                                                    onChange={value => onAdditionChange(row.ehpadId, value)}
                                                />
                                                <button
                                                    type="button"
                                                    aria-label={`Ajouter au crédit ${row.ehpadName}`}
                                                    disabled={dirty || saving || Number(additions[row.ehpadId]) <= 0}
                                                    onClick={() => onAdd(row.ehpadId)}
                                                    style={primaryButtonStyle}
                                                >
                                                    Ajouter
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td style={creditCellStyle}>
                                    <DateField label={`Date d'envoi ${row.ehpadName}`} value={current.sentDate} onChange={value => onChange(row, { sentDate: value })} />
                                </td>
                                <td style={{ ...creditCellStyle, minWidth: "280px" }}>
                                    <TextField label={`Remarque / Retour ${row.ehpadName}`} value={current.remark} onChange={value => onChange(row, { remark: value })} multiline />
                                </td>
                                <td style={creditCellStyle}>
                                    <DateField label={`Date de suivi ${row.ehpadName}`} value={current.followUpDate} onChange={value => onChange(row, { followUpDate: value })} />
                                </td>
                                <td style={creditCellStyle}>
                                    {dirty ? (
                                        <div style={{ display: "flex", gap: "7px" }}>
                                            <button type="button" disabled={saving} onClick={() => onSave(row.ehpadId)} style={primaryButtonStyle}>
                                                {saving ? "Enregistrement…" : "Enregistrer"}
                                            </button>
                                            <button type="button" disabled={saving} onClick={() => onCancel(row.ehpadId)} style={secondaryButtonStyle}>
                                                Annuler
                                            </button>
                                        </div>
                                    ) : row.updatedAt ? (
                                        <small style={{ color: "#94a3b8" }}>
                                            {new Date(row.updatedAt).toLocaleDateString("fr-FR")}<br />{row.updatedBy || ""}
                                        </small>
                                    ) : <span style={{ color: "#94a3b8" }}>—</span>}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
